"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _DropdownContext = require("./context/DropdownContext");

var _styles = require("./styles");
/* eslint-disable  */


var DropdownItem = function DropdownItem(_ref) {
  var children = _ref.children;

  var _useDropdown = (0, _DropdownContext.useDropdown)(),
      isOpen = _useDropdown.isOpen,
      changeDropdownState = _useDropdown.changeDropdownState;

  var Clone = _react.default.Children.map(children, function (child) {
    var handleMouseUp = function handleMouseUp() {
      return setTimeout(function () {
        changeDropdownState(!isOpen);
      }, 10);
    };

    if (typeof child.type !== 'function') {
      return /*#__PURE__*/_react.default.cloneElement(child, {
        className: 'dropdown-item',
        onMouseUp: handleMouseUp
      });
    }

    return /*#__PURE__*/_react.default.cloneElement(child, {
      className: 'dropdown-item'
    });
  });

  return /*#__PURE__*/_react.default.createElement(_styles.Item, null, Clone);
};

var _default = DropdownItem;
exports.default = _default;